import PropTypes from "prop-types"

import Article from "areas/helpdesk/article"
import fetchCollectionData from "hoc/helpdesk/fetch-collection-results"

const WrappedArticle = ({
  helpdeskArticle,
  helpdeskRelatedArticles,
  staticContext,
}) => {
  return (
    <Article
      helpdeskArticle={helpdeskArticle}
      helpdeskRelatedArticles={helpdeskRelatedArticles}
      staticContext={staticContext}
    />
  )
}

WrappedArticle.propTypes = {
  helpdeskArticle: PropTypes.object,
  helpdeskRelatedArticles: PropTypes.array,
  staticContext: PropTypes.object,
}

export default fetchCollectionData(WrappedArticle)
